import i18n from '../../locale';

export const splitCamelCaseIntoWords = (camelCaseString: string) => {
  return camelCaseString.split(/(?=[A-Z])/).join(' ');
};

export const capitalizeFirstLetter = (str: string): string => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
};

//TODO: add support for Locale
export const getOrdinalTerm = (ordinal: number) => {
  switch (ordinal) {
    case 1:
      return 'first';
    case 2:
      return 'second';
    case 3:
      return 'third';
    case 4:
      return 'fourth';
    case 5:
      return 'fifth';
    default:
      return '';
  }
};

export const formatPrice = (value: number, currency?: string) => {
  return i18n.t('price', {
    val: {
      value: value ?? 0,
      currency: currency || 'USD',
    },
  });
};

export const currencySymbol = (currency: string) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency })
    .formatToParts(1)
    .find((part) => part.type === 'currency').value;

export const currencyValue = (value: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .formatToParts(value)
    .filter((part) => part.type !== 'currency')
    .map((part) => part.value)
    .join('');

export function uppercaseFirstLetter(str: string) {
  if (!str?.length) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const checkIfStringIsUrl = (str: string) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator

  return !!pattern.test(str);
};

export const addProtocolToUrlIfNecessary = (url: string) => {
  if (url?.startsWith('http://') || url?.startsWith('https://')) {
    return url;
  }
  return `https://${url}`;
};

export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');

export const generateRandomPassword = (specialChars: string, minLength: number, maxLength: number) => {
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';

  // Generate a random length for the password
  const passwordLength = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;

  const password = [
    uppercase[Math.floor(Math.random() * uppercase.length)],
    lowercase[Math.floor(Math.random() * lowercase.length)],
    numbers[Math.floor(Math.random() * numbers.length)],
    specialChars[Math.floor(Math.random() * specialChars.length)],
  ];

  const allChars = uppercase + lowercase + numbers + specialChars;

  for (let i = 4; i < passwordLength; i++) {
    password.push(allChars[Math.floor(Math.random() * allChars.length)]);
  }

  return password.join('');
};
